import { render, staticRenderFns } from "./rahoituslaitos.vue?vue&type=template&id=bff1e6e6&"
import script from "./rahoituslaitos.vue?vue&type=script&lang=js&"
export * from "./rahoituslaitos.vue?vue&type=script&lang=js&"
import style0 from "./rahoituslaitos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports